<div class="titlebar">
  <div class="media-name">{{ title }}</div>
</div>
<div class="timers" *ngIf="vm">
  <div class="timer">
    <span class="time">
      {{ vm.videoWithoutCutDirectivesWithInsertsMs ? vm.timeFormatFunction(vm.videoWithoutCutDirectivesWithInsertsMs) : placeholder }}
    </span>
    <span class="name">Current Delay</span>
  </div>
  <div class="timer">
    <span class="time">
      {{ vm.setDelayMs ? vm.timeFormatFunction(vm.setDelayMs) : placeholder }}
    </span>
    <span class="name">Set Delay</span>
  </div>
  <div class="timer">
    <span class="time">
      {{ vm.overUnderRunMs ? vm.timeFormatFunction(vm.overUnderRunMs) : placeholder }}
    </span>
    <span class="name">Over / Under Run</span>
  </div>
  <div class="timer">
    <!--<span class="time" *ngIf="timelineRef">
  {{
        timelineRef.currentVideoTimeInMs() != null
          ? timeFormatFunction(timelineRef.currentVideoTimeInMs())
          : placeholder
      }}
</span>

    <span class="name">Video Duration</span>
  </div>-->
  <div class="timer">
    <span class="time">
      {{ videoTimeUtcMs ? vm.timeFormatFunction(videoTimeUtcMs ?? 0) : placeholder }}
    </span>
    <span class="name"> Current Video Time</span>
  </div>
</div>
<div class="buttons">
  <div class="action-buttons">
    <!--<div
      class="action-button"
      (click)="buttonClicked.emit('export-edl')"
      style="cursor: not-allowed"
    >
      <div class="transparent-outlined">export edl</div>
    </div>
    <div
      class="action-button"
      (click)="buttonClicked.emit('export')"
      style="cursor: not-allowed"
    >
      <div class="transparent-outlined">export</div>
    </div>-->
  </div>
  <div class="history-buttons">
    <div class="undo" (click)="vm.onHeaderButtonClicked('undo')" title="Undo">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.66128 4.53596C7.32654 4.20123 6.78391 4.20123 6.44917 4.53596L3.02059 7.96454C2.68585 8.29927 2.68585 8.84199 3.02059 9.17672L6.44917 12.6053C6.78391 12.94 7.32654 12.94 7.66128 12.6053C7.99603 12.2705 7.99603 11.7278 7.66128 11.3931L5.69602 9.42777H16.1981C18.8806 9.42777 21.0552 11.6024 21.0552 14.2849C21.0552 16.9674 18.8806 19.1421 16.1981 19.1421H8.19808C7.72471 19.1421 7.34094 19.5258 7.34094 19.9992C7.34094 20.4726 7.72471 20.8564 8.19808 20.8564H16.1981C19.8274 20.8564 22.7695 17.9142 22.7695 14.2849C22.7695 10.6556 19.8274 7.71349 16.1981 7.71349H5.69602L7.66128 5.74815C7.99603 5.41341 7.99603 4.87069 7.66128 4.53596Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>
    </div>
    <div class="redo" (click)="vm.onHeaderButtonClicked('redo')" title="Redo">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.8778 4.53596C18.2125 4.20123 18.7552 4.20123 19.0899 4.53596L22.5185 7.96454C22.8532 8.29927 22.8532 8.84199 22.5185 9.17672L19.0899 12.6053C18.7552 12.94 18.2125 12.94 17.8778 12.6053C17.543 12.2705 17.543 11.7278 17.8778 11.3931L19.843 9.42777H9.34098C6.65845 9.42777 4.48382 11.6024 4.48382 14.2849C4.48382 16.9674 6.65844 19.1421 9.34097 19.1421H17.341C17.8144 19.1421 18.1981 19.5258 18.1981 19.9992C18.1981 20.4726 17.8144 20.8564 17.341 20.8564H9.34097C5.71166 20.8564 2.76953 17.9142 2.76953 14.2849C2.76953 10.6556 5.71167 7.71349 9.34098 7.71349H19.843L17.8778 5.74815C17.543 5.41341 17.543 4.87069 17.8778 4.53596Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>
    </div>
    <div
      class="debug"
      [class.active]="vm.showDebugPanel"
      (click)="vm.showDebugPanel = !vm.showDebugPanel"
      title="HLS Debug Panel"
    >
      <svg
        width="25"
        height="25"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 8h-2.81a5.985 5.985 0 0 0-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>
    </div>
  </div>
</div>
